import api from '@/api'

export default {
  all: (filter) => api('get', '/client', filter),
  create: (data) => api('post', '/client', data),
  show: (id) => api('get', `/client/${id}`),
  delete: (id) => api('delete', `/client/${id}`),
  update: (data) => api('put', `/client/${data.id}`, data)
}